var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDrawer != null)?_c('v-navigation-drawer',{attrs:{"permanent":"","app":"","clipped":""}},[_c(_vm.showDrawer,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }